import Modal from "@/components/ui/Modal";
import { formatDate } from "@/utils/formateData";
import React, { useState } from "react";
import WithdrawRequestDetails from "./WithdrawRequestDetails";
import RejectModal from "./RejectModal";
import { useGlobalContext } from "@/context/GlobalContext";
import { handleApiRequest } from "@/utils/handleApiRequest";
import toast from "react-hot-toast";
import { TWithdrawRequest } from "@/redux/feature/balaneWithdraw/balanceWithdrawTypes";

const RequestsTable = ({ data }: { data: TWithdrawRequest[] }) => {
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<TWithdrawRequest | null>(
    null
  );
  const [isRejectModalOpen, SetRejectModalOpen] = useState(false);

  const tableHeaders = [
    { key: "name", label: "Name" },
    { key: "number", label: "Number" },
    { key: "email", label: "Email" },
    { key: "sta1tus", label: "Status" },
    { key: "amount", label: "Amount" },
    { key: "date", label: "Date" },
    { key: "1", label: "" },
    { key: "actions", label: "Actions" },
  ];

  // const orderStatus =
  // ) : (
  //   "Unknown"
  // );
  return (
    <>
      <div className="hidden mt-10 md:block overflow-x-auto rounded-xl border-[1.5px] border-[#D0D5DD]">
        {data?.length > 0 ? (
          <table className="w-full">
            <thead>
              <tr className="border-[#D0D5DD] border-b">
                {tableHeaders.map((header) => (
                  <th
                    key={header.key}
                    className="text-[13px] leading-[18px] tracking-[-3%] font-medium text-[#98A2B3] text-start py-5 px-6"
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((withDrawReq, i) => (
                <tr
                  key={i}
                  className="border-b-[1.5px] border-[#D0D5DD] h-[66px] last:border-0 hover:bg-gray-50"
                >
                  <td className="px-6">
                    <span className="text-[rgb(29,41,57)] truncate max-w-[200px] font-medium text-sm block mb-1">
                      {withDrawReq?.creator_id?.fullName}
                    </span>
                  </td>
                  <td className="px-6">
                    <p className="text-[#1D2939] whitespace-nowrap font-medium text-sm leading-[22px] tracking-[-1%]">
                      {withDrawReq?.creator_id?.phoneNumber}
                    </p>
                  </td>
                  <td className="px-6">
                    <p className="text-[#1D2939] whitespace-nowrap font-medium text-sm leading-[22px] tracking-[-1%]">
                      {withDrawReq?.creator_id?.email}
                    </p>
                  </td>
                  <td className="px-6">
                    {withDrawReq?.status === "pending" ? (
                      <p className="border  text-sm w-fit border-[#714B0029] bg-[#FBF1DA] text-[#714B00] py-[2px] px-2 rounded-xl">
                        Pending
                      </p>
                    ) : withDrawReq?.status === "rejected" ? (
                      <p className="border  text-sm w-fit border-[#714B0029] bg-[#fbdbda] text-[#714B00] py-[2px] px-2 rounded-xl">
                        Rejected
                      </p>
                    ) : (
                      withDrawReq?.status === "approved" && (
                        <p className="border text-sm  w-fit border-green-500 bg-green-50 text-green-700 py-[2px] px-2 rounded-xl">
                          Completed
                        </p>
                      )
                    )}
                  </td>
                  <td className="px-6">
                    <p className="text-[#1D2939] whitespace-nowrap font-medium text-sm leading-[22px] tracking-[-1%] ">
                      {withDrawReq?.currency} {withDrawReq.amount}
                    </p>
                  </td>
                  <td className="px-6">
                    <p className="text-[#1D2939] whitespace-nowrap font-medium text-sm leading-[22px] tracking-[-1%]">
                      {formatDate(withDrawReq?.createdAt)}
                    </p>
                  </td>

                  <td className="px-6"></td>
                  <td className="px-6">
                    <button
                      onClick={() => {
                        setSelectedData(withDrawReq);
                        setShowEditModal(true);
                      }}
                      type="button"
                      className="text-[#ED5E00] hover:text-orange-700 text-xs leading-[18px] cursor-pointer"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-20 text-center">
            <p>No Requests to show.</p>
          </div>
        )}
      </div>

      <Modal
        width="500px"
        padding="0px"
        preventCloseOnClickOutside={true}
        setOpen={setShowEditModal}
        isOpen={showEditModal}
      >
        <WithdrawRequestDetails
          onApprove={() => {}}
          onReject={() => {
            setShowEditModal(false);
            SetRejectModalOpen(true);
          }}
          loading={false}
          withdrawRequest={selectedData as TWithdrawRequest}
          onClose={() => setShowEditModal(false)}
        />
      </Modal>
    </>
  );
};

export default RequestsTable;
